import { Box } from '@chakra-ui/react';
import { useLingui } from '@lingui/react/macro';

import { useVoiceStore } from '#features/voice/model/voiceStore';

/**
 * Качество связи четырьмя делениями. Хорошая связь **молчит** — значок серый и без подписи:
 * постоянный зелёный индикатор ничего не сообщает, а место занимает.
 *
 * Показываем только своё качество: чужое человек всё равно не починит.
 */
export const VoiceQualityIcon = () => {
  const { t } = useLingui();
  const quality = useVoiceStore((s) => s.quality);

  if (quality === 'unknown') {
    return null;
  }

  const lit = quality === 'good' ? 3 : quality === 'unstable' ? 2 : 1;
  const color =
    quality === 'good'
      ? 'status.live.solid'
      : quality === 'unstable'
        ? 'orange.400'
        : 'red.400';

  const title =
    quality === 'good'
      ? t`post:voice.widget.qualityGood`
      : quality === 'unstable'
        ? t`post:voice.widget.qualityUnstable`
        : t`post:voice.widget.qualityLost`;

  return (
    <Box
      w="32px"
      h="32px"
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      color="fg.muted"
      title={title}
      aria-label={title}
    >
      <svg
        viewBox="0 0 24 24"
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M4 20v-3" stroke={lit >= 1 ? `var(--chakra-colors-${cssVar(color)})` : undefined} />
        <path d="M10 20v-8" stroke={lit >= 2 ? `var(--chakra-colors-${cssVar(color)})` : undefined} />
        <path d="M16 20v-13" stroke={lit >= 3 ? `var(--chakra-colors-${cssVar(color)})` : undefined} />
        <path d="M22 20V4" />
        {quality === 'lost' ? <path d="M2 2l20 20" /> : null}
      </svg>
    </Box>
  );
};

const cssVar = (token: string) => token.replaceAll('.', '-');
